var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "keg",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("rect", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          x: "40.622",
          y: "26.87",
          width: "18.44",
          height: "5.796",
          rx: "2.898",
          ry: "2.898",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m79.08,23.07v18.02H20.81v-18.02c0-1.1.9-2,2-2h54.27c1.11,0,2,.9,2,2Z",
        },
      }),
      _c("rect", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x: "20.81", y: "46.25", width: "58.27", height: "8.33" },
      }),
      _c("rect", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x: "20.81", y: "59.74", width: "58.27", height: "8.01" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m79.08,72.91v5.53c0,5.16-4.18,9.34-9.33,9.34H30.14c-5.15,0-9.33-4.18-9.33-9.34v-5.53h58.27Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m83.3,43.09v1.16c0,1.11-.9,2-2,2H18.6c-1.11,0-2-.89-2-2v-1.16c0-1.11.89-2,2-2h62.7c1.1,0,2,.89,2,2Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m83.3,56.58v1.16c0,1.1-.9,2-2,2H18.6c-1.11,0-2-.9-2-2v-1.16c0-1.11.89-2,2-2h62.7c1.1,0,2,.89,2,2Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m83.3,69.75v1.16c0,1.11-.9,2-2,2H18.6c-1.11,0-2-.89-2-2v-1.16c0-1.11.89-2,2-2h62.7c1.1,0,2,.89,2,2Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }